import styled from 'styled-components'

export const Container = styled.div<{ isCollapsed: boolean }>`
  position: relative;
  width: 100%;
  padding: 0.5rem 1rem 2rem 1rem;
  transition-delay: ${({ isCollapsed }) => (isCollapsed ? '0s' : '3s')};
  opacity: ${({ isCollapsed }) => (isCollapsed ? '0' : '1')};
  transition: opacity 0.5s ease-in-out;

  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: hidden;

  ${({ isCollapsed }) => isCollapsed && `p {white-space: nowrap; overflow: hidden; text-overflow: ellipsis;}`}
`

export const PatientInfoContainer = styled.div`
  width: 100%;
`

export const PatientInfoLabel = styled.p`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;

  color: ${props => props.theme.colors.color5a6a7e};
  white-space: nowrap;
`

export const PatientInfoContent = styled.p`
  margin-top: 4px;
  white-space: normal;

  font-family: 'Inter';
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;

  color: ${props => props.theme.colors.color2d3139};
`

export const PregnancyPatientPerspectiveEmptyContainer = styled.div`
  position: relative;
  height: 26px;
`
